export default "__VITE_ASSET__4ELiu2uE__"